/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import request from './utils/request'
import jsonp from './utils/jsonp'
import UmyUi from "umy-ui";
import "umy-ui/lib/theme-chalk/index.css"; // 引入样式
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Permission from './directives/permission'

Vue.use(UmyUi);
Vue.use(ElementUI);
Vue.use(Permission); // 注册权限指令

// 将 axios 实例挂载到 Vue 原型上
Vue.prototype.$http = request
// 将 jsonp 工具函数挂载到 Vue 原型上
Vue.prototype.$jsonp = jsonp

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
